$(document).ready(() => {
  $('#tabs div').on("click", function () {
    var this_id = $(this).attr("id")
    $('#tabs div').removeClass('text-myblue border-b border-myblue font-medium')
    $('#tabs div').addClass('border-white')
    $(this).addClass('text-myblue border-b !border-myblue font-medium')

    $('.tab_item').addClass('hidden')

    switch (this_id) {
      case 'intro_course_tab':
        $('#intro_course').removeClass('hidden')
        break;
      case 'session_tab':
        $('#sessions').removeClass('hidden')
        break;
      case 'license_tab':
        $('#license').removeClass('hidden')
        break;
      case 'comments_tab':
        $('#comments').removeClass('hidden')
        break;
      default:
        break;
    }
  });
  const urlParams = new URLSearchParams(window.location.search);
  const tabParam = urlParams.get('tab');
  if (tabParam) {
    $('.tab_item').addClass('hidden')
    $('#' + tabParam).removeClass('hidden')
    $('#tabs div').removeClass('text-myblue border-b border-myblue font-medium')
    $('#tabs div').addClass('border-white')
    $('#' + tabParam + '_tab').addClass('text-myblue border-b !border-myblue font-medium')
  }
  var swiper = new Swiper('.swiper-vertical-portfolio', {
    direction: 'vertical',
    pagination: false,
    rtl: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    slidesPerView: 3,
    spaceBetween: 16,
  });

  $('.swiper-vertical-portfolio .swiper-slide img').on('click', function () {
    var imgSrc = $(this).attr('src');
    $('#primary-image').attr('src', imgSrc);
  });
  $(".toggle-accordion").on("click", function () {
    $(".accordion-content").slideToggle('slow', function () {
      if (!jQuery(".accordion-content").is(":visible")) {
        jQuery(".accordion-status-btn").text("باز کردن جلسات");
      } else {
        jQuery(".accordion-status-btn").text("بستن جلسات");
      }
    });
  })
  var $firstButton = $(".learn-plans > button").first();
  $firstButton.removeClass("border border-border text-black").addClass("bg-myblue text-white");
  $firstButton.find("img").css("filter", "brightness(0) invert(1)");

  $(".learn-plans > button").on("click", function () {
    $(".learn-plans > button").removeClass("bg-myblue text-white").addClass("border border-border text-black");
    $(".learn-plans > button img").css("filter", "none");

    $(this).removeClass("border border-border text-black").addClass("bg-myblue text-white");
    $(this).find("img").css("filter", "brightness(0) invert(1)");
  });
  jQuery('.copy-on-clip').on('click', function () {
    var textToCopy = jQuery('.copy-element').text();
    var tempInput = jQuery('<input>');
    jQuery('body').append(tempInput);
    tempInput.val(textToCopy).select();
    document.execCommand('copy');
    tempInput.remove();
    alert("کپی شد!");
  });
  jQuery('.copy-on-clip-licence').on('click', function () {
    var textToCopy = jQuery('.copy-element-licence').text();
    var tempInput = jQuery('<input>');
    jQuery('body').append(tempInput);
    tempInput.val(textToCopy).select();
    document.execCommand('copy');
    tempInput.remove();
    alert("کپی شد!");
  });

  $(function () {
    const audioUrl = $('#intro-player').data('audio-url');

    Amplitude.init({
      songs: [
        {
          "name": "Dynamic Song",
          "artist": "Dynamic Artist",
          "url": audioUrl
        }
      ],
      visualizations: true,
      callbacks: {
        timeupdate: function () {
          let currentTime = Amplitude.getSongPlayedSeconds();
          let duration = Amplitude.getSongDuration();

          if (duration > 0) {
            let progressPercentage = (currentTime / duration) * 100;
            $('#progress-bar').val(progressPercentage);
          }

        }
      }
    });

    $('#progress-bar').on('click', function (e) {
      let progressBar = $(this);
      let offsetX = e.pageX - progressBar.offset().left;
      let progressBarWidth = progressBar.width();
      let clickPercentage = (offsetX / progressBarWidth);

      let songDuration = Amplitude.getSongDuration();

      if (songDuration > 0) {
        let seekTo = clickPercentage * songDuration;
        Amplitude.setSongPlayedPercentage(clickPercentage * 100);
        Amplitude.setSongPlayedSeconds(seekTo);
      }
    });
  });
  $('.more-player').on('click', function () {
    $('.dropdown-content').toggleClass('hidden');
  });
});
